export function agregarDatosEmpresaUsuario(formData) {
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    const idUsuario = JSON.parse(localStorage.getItem('user'))?.id

    if (idEmpresa) formData.append('empresa_id', idEmpresa)
    if (idUsuario) formData.append('user_id', idUsuario)

    return formData
}
